var exports = {
  "i": "ClaimAccountModal.module__resendRow___eW9rSj",
  "h": "ClaimAccountModal.module__status___eW9rSj",
};

module.exports = exports;
